import React from 'react';
import { Box, Typography, Grid, Container, Card, CardMedia, CardContent } from '@mui/material';
import bg11 from '../images/bg11.png'
import bg22 from '../images/bg22.png'
import bg33 from '../images/bg33.png'
import grid from '../images/grid.png'


const BenefitSection = () => {
  return (
    <Box
      sx={{
        bgcolor: '#000000',
        backgroundImage: `url(${grid})`,
        backgroundSize: 'cover',
        py: 8,
        px: { xs: 2, md: 4 }
      }}
    >
      <Container maxWidth="xl">
        {/* Main Heading */}
        <Box sx={{ mb: 6 }}>
          <Typography
            variant="h2"
            align="center"
            sx={{
              color: '#fad32e',
              fontWeight: 'bold',
              fontSize: { xs: '1.75rem', sm: '2.25rem', md: '2.75rem' },
              mb: 6
            }}
          >
            WHO CAN BENEFIT FROM HASHINFRA?
          </Typography>
        </Box>

        {/* Benefit Cards */}
        <Grid container spacing={4} justifyContent={'center'} alignItems="center">
          {/* Startups Card */}
          <Grid item xs={12} md={4}>
            <Card 
              sx={{ 
                height: '100%', 
                borderRadius: '16px',
                overflow: 'hidden',
                position: 'relative',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
              }}
            >
              <CardMedia
                component="img"
                height="400"
                src={bg11}
                alt="Startup team"
                sx={{
                  objectFit: 'cover'
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  //height: '100%',
                  background: 'linear-gradient(to top, rgba(0,0,0,1), transparent)',
                  p: 3,
                  zIndex: 1
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: '#fad32e',
                    fontWeight: 'bold',
                    fontFamily: 'Poppins, sans-serif',
                    mb: 1,
                    zIndex: 2
                  }}
                >
                  Startups
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#ffffff',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 'light',
                  }}
                >
                  Leverage our development expertise to develop custom solutions.
                </Typography>
              </Box>
            </Card>
          </Grid>

          {/* Enterprises Card */}
          <Grid item xs={12} md={4}>
            <Card 
              sx={{ 
                height: '100%', 
                borderRadius: '16px',
                overflow: 'hidden',
                position: 'relative',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
              }}
            >
              <CardMedia
                component="img"
                height="400"
                src={bg22}
                alt="Startup team"
                sx={{
                  objectFit: 'cover'
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  background: 'linear-gradient(to top, rgba(0,0,0,0.9), rgba(0,0,0,1), transparent)',
                  p: 3,
                  zIndex: 1
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: '#fad32e',
                    fontWeight: 'bold',
                    fontFamily: 'Poppins, sans-serif',
                    mb: 1
                  }}
                >
                  Enterprises
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#ffffff',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 'light',
                  }}
                >
                  Simplify microservice operations and improve scalability.
                </Typography>
              </Box>
            </Card>
          </Grid>

          {/* DevOps Teams Card */}
          <Grid item xs={12} md={4}>
            <Card 
              sx={{ 
                height: '100%', 
                borderRadius: '16px',
                overflow: 'hidden',
                position: 'relative',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
              }}
            >
              <CardMedia
                component="img"
                height="400"
                src={bg33}
                alt="Startup team"
                sx={{
                  objectFit: 'cover'
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  background: 'linear-gradient(to top, rgba(0,0,0,0.9), rgba(0,0,0,1), transparent)',
                  p: 3,
                  zIndex: 1
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: '#fad32e',
                    fontWeight: 'bold',
                    fontFamily: 'Poppins, sans-serif',
                    mb: 1
                  }}
                >
                  DevOps Teams
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#ffffff',
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 'light',
                  }}
                >
                  Automate workflows and optimize microservice management.
                </Typography>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default BenefitSection;